import React, { Component, Fragment } from 'react';
import {DateTime} from "luxon";
import cx from 'classnames';
import renderComponent from '../../Assets/scripts/composition/renderComponent';
import { loaderAnimTemplate } from '../../Assets/scripts/utils/loaderAnim';
import './index.scss';

const weatherInfoApiUrlTemplate = (lat, lng, culture, start, end) => `/api/v2/weather/info?lat=${lat}&lng=${lng}&culture=${culture.substring(0, 2)}&start=${start.toFormat('yyyy-MM-dd-HH-mm-ss')}&end=${end ? end.toFormat('yyyy-MM-dd-HH-mm-ss') : ''}`

class WeatherInfoComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            weatherInfo: null
        }
    }

    componentDidMount() {
        this.fetchWeatherInfo()
    }

    fetchWeatherInfo = async () => {
        this.setState({ isLoading: true })

        const options = JSON.parse(this.props.options)
        const { latitude, longitude, culture } = options
        const periodStart = DateTime.fromISO(options.periodStart)
        const periodEnd = options.periodEnd ? DateTime.fromISO(options.periodEnd) : null
        const requestUrl = weatherInfoApiUrlTemplate(latitude, longitude, culture, periodStart, periodEnd)

        const response = await fetch(requestUrl)
        const weatherInfo = await response.json()

        this.setState({
            isLoading: false,
            weatherInfo
        })
    }

    mapWeatherIcon = icon => {
        switch (icon) {
            case 'ClearSkyDay':
                return 'wb_sunny'
            case 'ClearSkyNight':
                return 'brightness_3'
            case 'FewCloudsDay':
            case 'FewCloudsNight':
                return 'wb_cloudy'
            case 'ScatteredCloudsDay':
            case 'ScatteredCloudsNight':
                return 'wb_cloudy'
            case 'BrokenCloudsDay':
            case 'BrokenCloudsNight':
                return 'wb_cloudy'
            case 'ShowerRainDay':
            case 'ShowerRainNight':
                return 'grain'
            case 'RainDay':
            case 'RainNight':
                return 'grain'
            case 'ThunderstormDay':
            case 'ThunderstormNight':
                return 'flash_on'
            case 'SnowDay':
            case 'SnowNight':
                return 'ac_unit'
            case 'MistDay':
            case 'MistNight':
                return 'blur_on'
            default:
                return 'brightness_1'
        }
    }

    renderWeatherForecastItem = item => {
        return (
            <Fragment key={item.date}>
                <span className="material-icons item-icon">{this.mapWeatherIcon(item.worstWeatherIcon)}</span>
                <strong className={cx('item-avg-temperature', { 'temperature-low': item.maxTemperature < 1, 'temperature-high': item.maxTemperature > 25 })}>{Math.ceil(item.maxTemperature)}°C</strong>
                <span className="item-weather-condition">{item.worstWeatherDescription}</span>
                <span className="item-time">({DateTime.fromISO(item.date).toLocaleString(DateTime.TIME_SIMPLE)})</span>
            </Fragment>
        )
    }

    render() {
        const { isLoading, weatherInfo } = this.state
        const options = JSON.parse(this.props.options)

        if (isLoading || !weatherInfo) {
            return <div dangerouslySetInnerHTML={{ __html: loaderAnimTemplate }} />
        } else if (!weatherInfo.isWeatherinfoAvailable) {
            return (
                <div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="items">
                        {weatherInfo.forecasts.map(this.renderWeatherForecastItem)}
                    </div>
                    <a className="stretched-link font-size-small no-target-indicator d-flex align-items-center" href={`https://openweathermap.org/city/${weatherInfo.cityId}`} rel="external nofollow" target="_blank">
                        {options.externalWeatherLinkText}
                        <span className="material-icons font-size-small ml-1">open_in_new</span>
                    </a>
                </div>
            )
        }
    }
}

async function initComponent(element) {
    renderComponent(WeatherInfoComponent, element)
}

$(function () {
    const elements = $('div.weather-info-component')

    for (const element of elements) {
        initComponent(element)
    }
})